import { z } from 'zod'
import { TRAINER_CONTRACT_VERSION, trainerEventSummarySchema, trainerWriteSideEffectsSchema } from './trainer-event-read'

const nullableString = z.string().nullable()
const optionalMutationString = nullableString.optional()
const optionalMutationNumber = z.number().finite().nullable().optional()
const optionalLegacyValue = z.unknown().optional()
const legacyCourseTypeId = optionalLegacyValue
const eventMutationFields = {
  description: optionalMutationString,
  event_date: optionalMutationString,
  participants_number: optionalMutationString,
  course_type: optionalMutationString,
  course_type_id: legacyCourseTypeId,
  courseTypeId: legacyCourseTypeId,
  budget: optionalMutationNumber,
  organisation_details: optionalMutationString,
  city: optionalMutationString,
  country: optionalMutationString,
  postal_code: optionalMutationString,
  venue_name: optionalMutationString,
  start_time: optionalMutationNumber,
  end_time: optionalMutationNumber,
} as const

/**
 * The transport contract deliberately keeps participants_number as a string.
 * This is a legacy Trainer wire quirk and is not normalized at the contract
 * boundary. The route retains its existing, more specific error messages.
 */
export const trainerEventCreateRequestSchema = z.object({
  name: z.string(),
  ...eventMutationFields,
}).passthrough()

export const trainerEventUpdateRequestSchema = z.object({
  events_id: z.unknown().optional(),
  name: z.unknown().optional(),
  ...eventMutationFields,
}).passthrough()

export const trainerEventArchiveRequestSchema = z.object({
  active: z.boolean(),
}).passthrough()

const trainerEventWriteResponseShape = {
  contract_version: z.literal(TRAINER_CONTRACT_VERSION),
  event: trainerEventSummarySchema,
  idempotentReplay: z.boolean(),
  sideEffects: trainerWriteSideEffectsSchema,
}

export const trainerEventCreateResponseSchema = z.object(trainerEventWriteResponseShape)
export const trainerEventUpdateResponseSchema = z.object(trainerEventWriteResponseShape)
export const trainerEventArchiveResponseSchema = trainerEventUpdateResponseSchema

export type TrainerEventCreateRequest = z.infer<typeof trainerEventCreateRequestSchema>
export type TrainerEventUpdateRequest = z.infer<typeof trainerEventUpdateRequestSchema>
export type TrainerEventArchiveRequest = z.infer<typeof trainerEventArchiveRequestSchema>
export type TrainerEventCreateResponse = z.infer<typeof trainerEventCreateResponseSchema>
export type TrainerEventUpdateResponse = z.infer<typeof trainerEventUpdateResponseSchema>
export type TrainerEventArchiveResponse = z.infer<typeof trainerEventArchiveResponseSchema>
